module.exports = __webpack_public_path__ + "img/hking-logo-en.9d6de484.png";